import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const PromoUpgradeLimit = () => {
    const { upgradeLimitTitle, upgradeLimitSubTitle, continueButton, notNowButton } = usePageMessages();
    const { nextPageLink } = useExtra();
    return (
        <InfoPage
            iconName="id-card-80"
            iconColor="primary"
            headerText={<DangerouslyHtml dangerouslyHtml={upgradeLimitTitle} />}
            secondaryText={<DangerouslyHtml dangerouslyHtml={upgradeLimitSubTitle} />}
            topButtonType="link"
            topButtonCaption={notNowButton}
            topButtonLink={AUTH_SEND_MAIN_LINK}
            primaryButtonCaption={continueButton}
            primaryButtonType="link"
            primaryButtonLink={nextPageLink}
        />
    );
};
export default PromoUpgradeLimit;
